import { Flex } from "@mantine/core";
import { useCallback, useMemo } from "react";

import { IGImage } from "@/features/common/components/IGImage";
import { SingleEnumFilter } from "@/features/common/components/filter/SingleEnumFilter";
import { useRequestQuery } from "@/features/common/hooks/useRequestQuery";
import {
  ModelOrderByWithRelationInput,
  ModelWhereInput,
  SortOrder,
} from "@/generated/graphql-hooks";
import CrownIcon from "@/icons/crown.svg";

const modelInstagramOrderByFilterList = {
  [SortOrder.Desc]: "粉絲人數: 由高至低",
  [SortOrder.Asc]: "粉絲人數: 由低至高",
};

export const ModelInstagramOrderByFilter = () => {
  const { query, setRequestQuery } = useRequestQuery<
    ModelWhereInput,
    ModelOrderByWithRelationInput
  >();

  const onSetFilter = useCallback(
    (value?: SortOrder) => {
      setRequestQuery({
        where: {
          ...query.where,
          AND: [
            { instagram: { not: { equals: null } } },
            { instagram: { not: { equals: "" } } },
          ],
        },
        orderBy: {
          instagramFollowerCount: { count: value },
        },
      });
    },
    [query, setRequestQuery],
  );

  const resetFilter = useCallback(() => {
    setRequestQuery({
      where: {
        ...query.where,
        AND: [],
      },
      orderBy: {},
    });
  }, [setRequestQuery, query.where]);

  const selectedValue = useMemo(() => {
    const orderByValue = query?.orderBy?.instagramFollowerCount?.count;

    return orderByValue ?? undefined;
  }, [query]);

  return (
    <SingleEnumFilter
      value={selectedValue}
      options={[
        { label: "預設排序", value: undefined },
        ...Object.entries(modelInstagramOrderByFilterList).map(
          ([value, label]) => ({
            value,
            label: (
              <Flex align="center">
                <IGImage />
                <span className="ml-1">{label}</span>
              </Flex>
            ),
          }),
        ),
      ]}
      resetFilter={resetFilter}
      renderChip={({ value }) => (
        <div className="justify-space-between flex items-center space-x-1">
          {!!value ? <IGImage /> : <CrownIcon height={18} width={18} />}

          <span className="font-light">
            {value ? modelInstagramOrderByFilterList[value] : "粉絲排序"}
          </span>
        </div>
      )}
      onSetFilter={onSetFilter}
    />
  );
};
